import type { Metric } from './types';

export function normalizeValueColumn(valueColumn?: string): string | undefined {
  return valueColumn && valueColumn.trim() !== '' ? valueColumn : undefined;
}

export function supportsMetricValueColumn(metric?: { isNumeric?: boolean; unitAggregationType?: string }): boolean {
  return metric?.isNumeric === true && metric.unitAggregationType !== 'count_distinct';
}

// valueColumn is emitted on the metric rep but excluded from the generated OpenAPI types.
export function getMetricValueColumn(metric: Metric): string | undefined {
  const { valueColumn } = metric as Metric & { valueColumn?: string };
  return normalizeValueColumn(valueColumn);
}

export function getMetricDenominatorValueColumn(denominator: Metric['denominator']): string | undefined {
  return normalizeValueColumn(denominator?.valueColumn);
}
